import { render, staticRenderFns } from "./SupportTicketDialogWaiting.vue?vue&type=template&id=73014590"
import script from "./SupportTicketDialogWaiting.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogWaiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports